export const STATUS = 'statusText';
export const INVOICE_NUMBER = 'invoiceNumber';
export const INVOICE_DATE = 'invoiceDate';
export const BILLING_DATE = 'billingDate';
export const DUE_DATE = 'dueDate';
export const CURRENCY = 'currency';
export const AMOUNT = 'amount';
export const PO_NUMBER = 'poNumber';
export const DAYS_LATE = 'daysLate';
export const LOCAL_TAX_INVOICE_NUMBER = 'localTaxInvoiceNumber';
export const SHIP_TO_CODE = 'shipToCode';
export const SOLD_TO_CODE = 'soldToCode';
export const ORDER_NUMBER = 'orderNumber';
export const DELIVERY_NUMBER = 'deliveryNumber';
